import { Link } from "react-router-dom";

export function LandingCta() {
  return (
    <section className="bg-near-black py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl sm:text-5xl font-bold text-white leading-tight tracking-tight">
          Ready to hire smarter?
        </h2>
        <p className="mt-4 text-lg text-white/50 max-w-xl mx-auto">
          Join HR outsourcing firms and enterprise talent teams that trust PipeTalent AI
          to screen, score, and deliver.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/signup"
            className="inline-flex items-center justify-center rounded-btn bg-rausch px-10 py-4 text-base font-semibold text-white hover:bg-[#e0334f] transition-colors shadow-lg"
          >
            Start Screening Today
          </Link>
          <a
            href="#pricing"
            className="inline-flex items-center justify-center rounded-btn border border-white/20 px-10 py-4 text-base font-semibold text-white hover:bg-white/5 transition-colors"
          >
            See Pricing
          </a>
        </div>
      </div>
    </section>
  );
}
